import { faIgloo } from "@fortawesome/free-solid-svg-icons";
import { call, put, takeEvery } from "redux-saga/effects";
import { createRegionWithMapAction } from "../api/map-action";
import {
  createFlatRegionAction,
  createPriorityRegion,
  deleteFlatRegionAction,
  deletePriorityRegionAction,
  deleteRegionAction,
  getAllFlatRegionsAction,
  getFLatRegionsOrSearchAction,
  getFlatRegionByIdAction,
  getFlatRegionMetaDataAction,
  getPriorityRegions,
  getRegionByIdAction,
  getRegionMetaDataAction,
  getRegionsOrSearchAction,
  regionSearchAction,
  transferRegionToFlatreginAction,
  updateFlatRegionAction,
  updateFlatRegionMetaDataAction,
  updateRegionAction,
  updateRegionMetaDataAction,
} from "../api/region-action";
import {
  getRegion,
  setAllRegions,
  setFlatPriorityRegions,
  setFlatRegionData,
  setFlatRegionMetaData,
  setFlatRegions,
  setIsUpdating,
  setRegionMetaData,
} from "../redux/app/regions/region-slice";
import { toast } from "react-toastify";
import {
  getRegions,
  getTotalFlatRegions,
  setRegionLoading,
} from "../redux/app/map/map-slice";

export function* getAllRegionsOrSearchSaga(actions) {
  try {
    const response = yield call(getRegionsOrSearchAction, actions.payload);
    yield put(setAllRegions({ allRegionsOrSearch: response.data }));
  } catch (error) {}
}

export function* createRegion(actions) {
  try {
    const response = yield call(createRegionWithMapAction, actions.payload);
    if (response.status === 200) {
      toast.success("Region Created Successfully");
      yield put({
        type: "GET_REGIONS",
      });
      actions.payload.navigate("/regions");
    }
  } catch (error) {}
}

export function* getRegionByIdSaga(actions) {
  const response = yield call(getRegionByIdAction, actions.payload);

  yield put(
    getRegion({
      region: response?.data?.data[0],
    })
  );
}

export function* updateRegion(actions) {
  try {
    yield put(
      setIsUpdating({
        isUpdating: true,
      })
    );
    const response = yield call(updateRegionAction, actions.payload);
    if (response.status === 200) {
      toast.success("Region Updated Successfully");
      yield put({
        type: "GET_REGION_BY_ID",
        payload: {
          regionId: actions.payload.regionId,
          token: actions.payload.token,
        },
      });
      yield put(
        setIsUpdating({
          isUpdating: false,
        })
      );
      window.location.relode();
    }
  } catch (error) {}
}

export function* regionSearchSaga(actions) {
  try {
    yield put(
      setRegionLoading({
        regionLoading: true,
      })
    );
    const response = yield call(regionSearchAction, actions.payload);

    if (response.status === 200) {
      yield put(
        setRegionLoading({
          regionLoading: false,
        })
      );

      yield put(getRegions({ regions: response?.data?.data }));
    }
  } catch (error) {}
}

export function* regionDeletesaga(action) {
  try {
    const response = yield call(deleteRegionAction, action.payload);

    if (response.status === 200) {
      toast.success("Region deleted");
      yield put({
        type: "GET_REGIONS",
      });
    }
  } catch (err) {
    toast.error(err);
  }
}

export function* getFlatRegionSaga(action) {
  try {
    const response = yield call(getAllFlatRegionsAction, action.payload);

    if (response.status === 200) {
      yield put(
        setFlatRegions({
          flatRegions: response?.data?.data?.flatRegions,
        })
      );
      yield put(
        getTotalFlatRegions({
          totalFlatRegions: response?.data?.totalFlatRegions,
        })
      );
    }
  } catch (error) {}
}

function* getFlatRegionSearchSaga(actions) {
  try {
    yield put(
      setRegionLoading({
        regionLoading: true,
      })
    );
    const response = yield call(getFLatRegionsOrSearchAction, actions.payload);

    if (response.success === true) {
      yield put(
        setRegionLoading({
          regionLoading: false,
        })
      );

      yield put(
        setFlatRegions({
          flatRegions: response?.data,
        })
      );
    }
  } catch (error) {}
}

export function* getFlatRegionIdSaga(action) {
  try {
    const response = yield call(getFlatRegionByIdAction, action.payload);

    if (response.status === 200) {
      yield put(
        setFlatRegionData({
          flatRegionData: response?.data?.data?.flatRegionData,
        })
      );
    }
  } catch (error) {
    toast.error(error);
  }
}

export function* updateFlatRegion(action) {
  try {
    const response = yield call(updateFlatRegionAction, action.payload);

    if (response.status === 200) {
      toast.success("Flat Region Updated Successfully");
      yield put(
        setFlatRegionData({
          flatRegionData: response?.data?.data?.flatRegion,
        })
      );
      yield put(
        setIsUpdating({
          isUpdating: false,
        })
      );
      window.location.relode();
    }
  } catch (error) {}
}

function* deleteFlatRegion(action) {
  try {
    toast.loading("Deleting Flat Region");
    const response = yield call(deleteFlatRegionAction, action.payload);

    if (response.status === 200) {
      toast.dismiss();
      toast.success("Flat Region deleted");
      yield put({
        type: "GET_FLAT_REGIONS",
        payload: {
          token: action.payload.token,
        },
      });
    }
  } catch (err) {
    toast.error(err);
  }
}

function* createFlatRegionSaga(actions) {
  try {
    toast.loading("Creating Flat Region");
    const response = yield call(createFlatRegionAction, actions.payload);
    if (response.status === 200) {
      toast.dismiss();
      toast.success("Flat Region Created Successfully");
      yield put({
        type: "GET_FLAT_REGIONS",
      });
      actions.payload.navigate("/flatregions");
    }
  } catch (error) {}
}

function* updateRegionMetaDataSaga(action) {
  try {
    toast.loading("Updating Region");
    const response = yield call(updateRegionMetaDataAction, action.payload);
    if (response.status === 200) {
      toast.dismiss();
      toast.success("Region Updated Successfully");
      yield put({
        type: "GET_REGION_META_DATA",
        payload: {
          regionId: action.payload.regionId,
          token: action.payload.token,
        },
      });
      window.location.relode();
    }
  } catch (error) {
    toast.error(error);
  }
}

function* getRegionMetaDatSaga(action) {
  try {
    const response = yield call(getRegionMetaDataAction, action.payload);
    if (response.status === 200) {
      yield put(
        setRegionMetaData({
          regionMetaData: response?.data?.data,
        })
      );
    }
  } catch (error) {
    toast.error(error);
  }
}

function* updateFlatRegionSaga(action) {
  try {
    toast.loading("Updating Flat Region");
    const response = yield call(updateFlatRegionMetaDataAction, action.payload);
    if (response.status === 200) {
      toast.dismiss();
      toast.success("Flat Region Updated Successfully");
      yield put({
        type: "GET_FLAT_REGION_META_DATA",
        payload: {
          regionId: action.payload.regionId,
          token: action.payload.token,
        },
      });
      window.location.relode();
    }
  } catch (error) {
    toast.error(error);
  }
}

function* getFlatRegionMetaDataSaga(action) {
  try {
    const response = yield call(getFlatRegionMetaDataAction, action.payload);
    if (response.status === 200) {
      yield put(
        setFlatRegionMetaData({
          flatRegionMetaData: response?.data?.data,
        })
      );
    }
  } catch (error) {
    toast.error(error);
  }
}

function* transferRegionToFlatreginSaga(action) {
  try {
    toast.loading("Transferring Region to Flat Region");
    const response = yield call(
      transferRegionToFlatreginAction,
      action.payload
    );
    if (response.status === 200) {
      toast.dismiss();
      toast.success("Region Transferred to Flat Region Successfully");
    }
  } catch (error) {
    toast.error(error);
  }
}

function* createPriorityRegionSaga(action) {
  try {
    toast.loading("Creating Priority Region");
    const response = yield call(createPriorityRegion, action.payload);
    if (response.status === 200) {
      toast.dismiss();
      yield put({
        type: "GET_PRIORITY_REGIONS",
        payload: {
          token: action.payload.token,
        },
      });
      toast.success("Priority Region Created Successfully");
    }
  } catch (error) {
    toast.error(error);
  }
}

function* getPriorityRegionListSaga(action) {
  try {
    const response = yield call(getPriorityRegions, action.payload);
    if (response.status === 200) {
      console.log(response?.data?.data?.priorityRegion, "<<9response");
      yield put(
        setFlatPriorityRegions({
          flatPriorityRegions: response?.data?.data?.priorityRegion,
        })
      );
    }
  } catch (error) {
    toast.error(error);
  }
}
function* deletePriorityRegionSaga(action) {
  try {
    toast.loading("Deleting Priority Region");
    const response = yield call(deletePriorityRegionAction, action.payload);
    if (response.status === 200) {
      toast.dismiss();

      yield put({
        type: "GET_PRIORITY_REGIONS",
        payload: {
          token: action.payload.token,
        },
      });
      toast.success("Priority Region Deleted Successfully");
    }
  } catch (error) {
    toast.error(error);
  }
}

export function* watchRegionAsync() {
  yield takeEvery("GET_ALL_REGION_OR_SEARCH", getAllRegionsOrSearchSaga);
  yield takeEvery("CREATE_REGION", createRegion);
  yield takeEvery("GET_REGION_BY_ID", getRegionByIdSaga);
  yield takeEvery("UPDATE_REGION", updateRegion);
  yield takeEvery("REGION_SEARCH", regionSearchSaga);
  yield takeEvery("REGION_DELETE", regionDeletesaga);
  yield takeEvery("GET_FLAT_REGIONS", getFlatRegionSaga);
  yield takeEvery("GET_FLAT_REGION_BY_ID", getFlatRegionIdSaga);
  yield takeEvery("UPDATE_FLAT_REGION", updateFlatRegion);
  yield takeEvery("GET_FLAT_REGION_OR_SEARCH", getFlatRegionSearchSaga);
  yield takeEvery("DELETE_FLAT_REGION", deleteFlatRegion);
  yield takeEvery("CREATE_FLAT_REGION", createFlatRegionSaga);
  yield takeEvery("UPDATE_REGION_META_DATA", updateRegionMetaDataSaga);
  yield takeEvery("GET_REGION_META_DATA", getRegionMetaDatSaga);
  yield takeEvery("UPDATE_FLAT_REGION_META_DATA", updateFlatRegionSaga);
  yield takeEvery("GET_FLAT_REGION_META_DATA", getFlatRegionMetaDataSaga);
  yield takeEvery(
    "TRANSFER_REGION_TO_FLAT_REGION",
    transferRegionToFlatreginSaga
  );
  yield takeEvery(
    "CREATE_PRIORITY_REGION_FLATREGION",
    createPriorityRegionSaga
  );
  yield takeEvery("GET_PRIORITY_REGIONS", getPriorityRegionListSaga);
  yield takeEvery("DELETE_PRIORITY_REGION", deletePriorityRegionSaga);
}
